<ui-subnav-item value="Overview" link="/gx/overview" icon="griddy-heart" />

<ui-subnav-item value="Messaging rules" link="/gx/rules" icon="griddy-email" />
<!-- Messaging rules children -->
@if (showChildren() === 'messaging-rules' || showChildren() === 'all') {
  <section>
    <ui-subnav-item
      value="Before booking"
      link="/gx/rules/segments/d0202cc5-4ec1-4a98-b983-b4c2a7a31ec8"
      variant="child" />
    <ui-subnav-item
      value="Before check-in"
      link="/gx/rules/segments/47dd6325-87dc-48e1-bebd-e68f532410ca"
      variant="child" />
    <ui-subnav-item value="Staying" link="/gx/rules/segments/98b45629-22ea-4dbe-9195-7ef764ba5d03" variant="child" />
    <ui-subnav-item
      value="After check-out"
      link="/gx/rules/segments/947ef9f9-fa54-4ec9-84d6-dbd3c3ba140c"
      variant="child" />
  </section>
}

<ui-subnav-item value="Review rules" link="/gx/reviews" icon="griddy-star" />
<ui-subnav-item value="Questions" link="/gx/questions" icon="griddy-help-circle" />
<ui-subnav-item value="Custom codes" link="/gx/custom-codes" icon="griddy-code" />
<ui-subnav-item value="Canned responses" link="/gx/canned-responses" icon="griddy-email-forward" />

@if (isUpsellsEnabled()) {
  <ui-subnav-item value="Upsells" link="/gx/upsells" icon="griddy-currency-exchange" [isNew]="true" />
}

@if (isInboxAIEnabled()) {
  <ui-subnav-item value="Inbox AI" link="/gx/inbox-ai" icon="griddy-sparks" [isNew]="true" />
}

<ui-subnav-item value="Guest portal" link="/gx/rental-agreements" icon="griddy-user-circle" />
<!-- Guest portal children -->
@if (showChildren() === 'guest-portal' || showChildren() === 'all') {
  <section>
    <ui-subnav-item value="Rental agreements" link="/gx/rental-agreements" variant="child" />
    <ui-subnav-item value="Task reminders" link="/gx/task-reminders" variant="child" />
    <ui-subnav-item value="Settings" link="/gx/portal-configuration" variant="child" />
  </section>
}

<ui-subnav-item value="Log" link="/gx/log" icon="griddy-console" />
<!-- Log children -->
@if (showChildren() === 'log' || showChildren() === 'all') {
  <section>
    <ui-subnav-item value="Events" link="/gx/log/events" variant="child" />
    <ui-subnav-item value="Scheduled" link="/gx/log/scheduled" variant="child" />
    <ui-subnav-item value="Questions" link="/gx/log/questions" variant="child" />
    <ui-subnav-item value="Reviews" link="/gx/log/reviews" variant="child" />
  </section>
}

<ui-subnav-item value="Settings" link="/settings/gx" icon="griddy-settings" />
